import { render, staticRenderFns } from "./RoomTypeList.vue?vue&type=template&id=470269be&scoped=true&"
import script from "./RoomTypeList.vue?vue&type=script&lang=js&"
export * from "./RoomTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470269be",
  null
  
)

export default component.exports